<template>
    <el-drawer
         title="新增置顶演出"
       :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="600px"
           @close="close" append-to-body
    >
	
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"

            >
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="24" :xl="24">
                        <el-form-item prop="activityId" label="演出ID:">
                            <el-input v-model="formData.activityId" @input="onInput" placeholder="请填写演出ID" />
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :xl="24">
						<el-form-item prop="settingType" label="">
							<span slot="label">置顶城市:</span>
						    <el-radio-group v-model="formData.settingType">
						        <el-radio :label="0">全国置顶</el-radio>
						        <el-radio :label="1">只在下面地区置顶</el-radio>
						        <el-radio :label="2"><span style="color:#F56C6C">不在</span>下面地区置顶</el-radio>
						    </el-radio-group>
						</el-form-item>
						<el-form-item prop="sellArea" v-if="formData.settingType != 0">
						    <span slot="label">地区设置:</span>
						    <el-cascader v-model="sellArea" :options="cityList" filterable
						        :props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, checkStrictly: true }"
						        style="width:100%" ref="cityCascader">
						    </el-cascader>
							<small class="MT10 red">
							    <span class="el-icon-warning"></span>  
							      如果需要在多个城市置顶，系统会为每个城市创建单独的置顶记录。如果同时设置了省份和省份下的某个城市展示
								  ，则全省展示。如果同时设置了省份和省份下的某个城市不展示，则全省不展示。
							</small>
						</el-form-item>
                    </el-col>
					<el-col :xs="24" :sm="24" :xl="24">
						<el-form-item prop="time1" label="展示时间段1:">
						    <div class="form-flex">
						        <el-date-picker v-model="time1" type="datetimerange" range-separator="至"
						            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
						            start-placeholder="开始日期" end-placeholder="结束日期"
						            unlink-panels size="medium"  :rules="[{ required: true, message: '请设置展示时间段' }]">
						        </el-date-picker>
						    </div>						    
						</el-form-item>						
						<el-form-item prop="time2" label="展示时间段2:">
						    <div class="form-flex">
						        <el-date-picker v-model="time2" type="datetimerange" range-separator="至"
						            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
						            start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels size="medium">
						        </el-date-picker>
						    </div>
						</el-form-item>						
						<el-form-item prop="time3" label="展示时间段3:">
						    <div class="form-flex">
						        <el-date-picker v-model="time3" type="datetimerange" range-separator="至"
						            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
						            start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels size="medium">
						        </el-date-picker>
						    </div>
						    <small class="MT10 red">
						        <span class="el-icon-warning"></span>最晚的展示时间段到期后，会自动删除置顶演出
						    </small>
						</el-form-item>
					</el-col>
                </el-row>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
import { fetchAllCity } from '@/assets/js/commonApi'

export default {
    components: {
       
    },
    props: {
        detail: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        
    },
    data(){
        return{
			drawerShow: false,
            btnLoading:false,
			time1: [],
			time2: [],
			time3: [],
            //cityOptions: [],
			sellArea:[],
			cityList: [],
            formData: {
                city: [],
				province:[],
                activityId: '',				
                id: '',
				settingType:0
            },
			pickerOptions:{
			    disabledDate(time) {
			        return time.getTime() < Date.now();
			    },
			},
            rules: {
                city: [{ required: true, message: "请选择城市" }],
                activityId: [{ required: true, message: "请填写演出ID" }],
				
            }
        }
    },
	async created() {
		
	},
    methods:{
		show(){
			this.drawerShow = true;
			this.getCityList();
		},
        close() {
            this.formData = {
                city: [],
                activityId: '',
				province:[],
                id: '',
				settingType:0
            };
			this.time1 = [],
			this.time2 = [],
			this.time3 = [],
			//cityOptions: [],
			this.sellArea = [],
			this.cityList = [],
            this.drawerShow = false;
        },
        onInput (value) {
            if (!/^[0-9]+$/.test(value)) this.formData.activityId = '';
        },
		//获取城市列表
		async getCityList() {
		    const res = await fetchAllCity({}).catch(() => { });
		    const { state, result } = res.data;
		    if (state == 1) {
		        this.cityList = result;
		    }
		},
        async submitForm(){
			
			if( this.formData.settingType != 0 && this.sellArea.length ==0 ){
				this.$message.warning('城市不能为空');
				return
			}
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    const form = JSON.parse(JSON.stringify(this.formData));
                    // form.city = form.city.toString();
					
					form.province = [];
					form.city = [];
					this.sellArea.map(item => {
					    if (!form.province.find(v => v == item[0]) && !item[1]) {
					        form.province.push(item[0]);
					    }
					    item[1] && form.city.push(item[1]);
					})
					
					form.firstStartDate = this.time1 && this.time1 [0] || '';
					form.firstEndDate = this.time1 && this.time1[1] || '';
					form.secondStartDate = this.time2 && this.time2[0] || '';
					form.secondEndDate = this.time2 && this.time2[1] || '';
					form.startDate = this.time3 && this.time3[0] || '';
					form.autoDeleteTime = this.time3 && this.time3[1] || '';
					
					
					
                    const response = await this.$request({
                        url:'/activityTop/create',
                        method:'post',
                        data: form
                    })
                    const {msg, state} = response.data;
                    if (state != 1) return this.$message.error(msg);
                    this.$message.success('操作成功');
                    this.close()
                    this.$emit('onUpdate');
                }
            });
            
        }
    }
}
</script>
<style lang="scss" scoped>
	.red{
		color:#F56C6C
	}
</style>